import Proptypes from 'prop-types';
import React, { useCallback } from 'react';

import { RiFontSize } from 'react-icons/ri';

import NewDropDown from './NewDropDown';

export default function FontSizeFormatter({ editor, tooltipText, value, ...props }) {
  const handleClickOption = useCallback(fontSize => {
    fontSize = fontSize.replace('px', '')
    const newValue = fontSize === 'Normal' || fontSize === value ? null : fontSize.replace('px', '')
    return editor.commands.setFontSize(newValue)
  }, [editor, value])

  return <NewDropDown
    options={SIZES}
    onClickOption={handleClickOption}
    tooltipText={tooltipText}
    icon={RiFontSize} {...props}
    name='fontSize'
    editor={editor}
    creatable
  />
}

const SIZES = ['Normal', '8px', '9px', '10px', '11px', '12px', '14px', '18px', '24px', '30px', '36px', '48px', '60px', '72px', '96px']

FontSizeFormatter.propTypes = {
  editor: Proptypes.object,
  tooltipText: Proptypes.string,
}
